import { Outlet, useNavigate } from 'react-router-dom'
import { useCallback } from 'react'

import { SibPageShell } from '@/components/layout/SibPageShell'
import { useUserStore } from '@/stores/user.store'
import { SUPPORT_PORTAL_URL } from '@/config'
import { EMPTY_ACTIVITY } from '@/common/activity.common'
import { getUserDisplayName } from '@/helper/common.helper'
import { endUserSession } from '@/providers/auth/session'

export function UserPortalLayout() {
  const { user, profile } = useUserStore()
  const navigate = useNavigate()

  const displayName = getUserDisplayName(user, profile)
  const dashboardPath = user?.role === 'admin' ? '/bo/dashboard' : '/app/user/dashboard'

  const handleNewOrder = useCallback(() => {
    navigate(dashboardPath, { state: { action: 'new-order' } })
  }, [navigate, dashboardPath])

  const handleAddActivity = useCallback(() => {
    navigate('/activities/new', {
      state: {
        values: {
          ...EMPTY_ACTIVITY,
          date: new Date(),
        },
      },
    })
  }, [navigate])

  const handleCreateInvoice = useCallback(() => {
    navigate(dashboardPath, { state: { action: 'create-invoice' } })
  }, [navigate, dashboardPath])

  const handleLogout = async () => {
    // Central teardown (SIB-924): server logout + full client session reset,
    // including the user store. Local cleanup happens even if the server call fails.
    await endUserSession()
    navigate('/login', { replace: true })
  }

  return (
    <SibPageShell
      userName={displayName}
      onNewOrder={handleNewOrder}
      onAddActivity={handleAddActivity}
      onCreateInvoice={handleCreateInvoice}
      onGoDashboard={() => navigate(dashboardPath)}
      onOpenSupport={() => window.open(SUPPORT_PORTAL_URL, '_blank')}
      onLogout={handleLogout}
    >
      <Outlet />
    </SibPageShell>
  )
}
